export default __webpack_public_path__ + "static/1910_1920-29ed9e11df01d3abb892f6ec3d1817ed.jpg";